/** User-facing app version shown in Settings → About. Bump manually on releases. */
export const APP_VERSION = '1.5.4';
